jQuery(document).ready(function () {
    const $views = jQuery('.wm-referencesFullView__view');
    jQuery('input[name=reference-type]').change(function () {
        const target = jQuery(this).val();
        const $target = target == 'all' ? $views : jQuery('#' + target);
        $views.fadeOut(200);
        setTimeout(() => {
            $target.fadeIn();
        }, 200);
    });
});
